import { EditLayoutWithMedia } from '../../../components/EditLayoutWithMedia';

export class LayoutOrgPartner extends EditLayoutWithMedia {

  constructor(props) {
    super(props, {pageForOrgType: 'PARTNER'})
  }
}


// WEBPACK FOOTER //
// ./src/screens/admin/partners/LayoutOrgPartner.js